<template>
  <v-dialog v-model="show" width="650px">
    <!-- <v-container> -->
    <v-card class="pa-4">
      <h3 class="mb-2">Create your first units</h3>

      <!-- render root groups -->
      <tree-node
        v-for="(node, index) in tree"
        :key="index"
        :node="node"
        :parent="tree"
        :index="index"
      />

      <!-- Add root group -->
      <div class="d-flex justify-end">
        <v-btn
          small
          color="secondary"
          class="mt-3"
          depressed
          @click="addRootGroup"
        >
          + Add Group
        </v-btn>
      </div>
      <v-divider class="my-4"></v-divider>
      <div class="d-flex justify-end">
        <v-btn color="primary" depressed @click="commitChanges">Submit</v-btn>
      </div>
    </v-card>
    <!-- </v-container> -->
  </v-dialog>
</template>

<script>
import TreeNode from './TreeNode.vue'

export default {
  components: { TreeNode },
  data: () => ({
    show: false,
    tree: [
      {
        type: 'group',
        name: 'Group 1',
        index: 0,
        children: [
          { type: 'unit', name: 'Unit 1', index: 0 },
          {
            type: 'group',
            name: 'Subgroup 1',
            index: 1,
            children: [{ type: 'unit', name: 'Unit 1', index: 0 }]
          }
        ]
      },
      {
        type: 'group',
        name: 'Group 2',
        index: 1,
        children: []
      }
    ]
  }),
  methods: {
    showDialog() {
      this.show = true
    },
    addRootGroup() {
      this.tree.push({
        type: 'group',
        name: 'Group ' + (this.tree.length + 1),
        children: []
      })
    },
    async commitChanges() {
      this.$root.$setLoading(true)
      try {
        await this.$store.dispatch('units/insertPropertyUnitListFromTemplate', {
          template: this.tree
        })
      } catch (err) {
        this.$root.$snack(err.message)
      } finally {
        this.$root.$setLoading(false)
      }

      window.location.reload()
    }
  }
}
</script>
